import type { AxiosResponse } from "axios";
import axiosClient from "../axiosClient";
import type { LoginFormData } from "@/pages/Login/store/types";

type LoginResponse = {
  token: string;
  refreshToken: string;
};

type RegisterResponse = string;

type ConfirmPhoneResponse = {
  id: number;
};

type ConfirmUserResponse = {
  token: string;
  refreshToken: string;
};

export const loginReq = async ({
  phone,
  password,
}: LoginFormData): Promise<AxiosResponse<LoginResponse>> => {
  return await axiosClient.post<LoginResponse>(`/auth/login`, {
    phone,
    password,
  });
};

export const registerReq = async (data: {
  phone: string;
}): Promise<AxiosResponse<RegisterResponse>> => {
  return await axiosClient.post<RegisterResponse>(`/auth/register`, data);
};

export const confirmPhoneReq = async (data: {
  phone: string;
  password: string;
}): Promise<AxiosResponse<ConfirmPhoneResponse>> => {
  return await axiosClient.post<ConfirmPhoneResponse>(
    `/auth/confirm-phone`,
    data
  );
};

export const confirmUserReq = async (
  id: number,
  data: {
    name: string;
    surname: string;
    password: string;
    phone: string;
  }
): Promise<AxiosResponse<ConfirmUserResponse>> => {
  return await axiosClient.post<ConfirmUserResponse>(
    `/auth/confirm-user/${id}`,
    data
  );
};

export const resetPasswordReq = async (data: {
  phone: string;
}): Promise<AxiosResponse<boolean>> => {
  return await axiosClient.post<boolean>(`/auth/reset`, data);
};

export const confirmResetPasswordCodeReq = async (data: {
  phone: string;
  password: string;
}): Promise<AxiosResponse<boolean>> => {
  return await axiosClient.post<boolean>(`/auth/confirm-reset`, data);
};

export const newPasswordReq = async (data: {
  phone: string;
  password: string;
}): Promise<AxiosResponse<boolean>> => {
  return await axiosClient.post<boolean>(`/auth/new-password`, data);
};

export const getTenantNameByPhoneReq = async (
  phone: string
): Promise<AxiosResponse<{ name: string; surname: string }>> => {
  return await axiosClient.get<{ name: string; surname: string }>(
    `/auth/recipients/${phone}`
  );
};
